import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { NzModalRef, NzNotificationService } from "ng-zorro-antd";
import { GetInfomationField } from 'src/app/models/forms-get.models';
import { FormFieldInfo } from 'src/app/models/forms-response.models';
import { FormsService } from 'src/app/services/forms.service';

@Component({
    selector: 'app-component-eform-modal',
    templateUrl: './eform-modal.component.html',
    styleUrls: ['./eform-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EformModalComponent implements OnInit {
    @Input() formFieldInfo: FormFieldInfo[];
    @Input() data: any;
    @Input() template: string;
    formGroup: FormGroup = this.formBuilder.group({});
    formFieldConfig: any;
    fieldConfig: any;
    fieldCode: string;
    version: number;
    name: string;
    maxlength: string = '';
    hideTitle: boolean;
    isRefresh: boolean = false;
    value: string = '';
    tooltip: any = {};
    content: any;
    header: any;
    body: any;
    rawContent: any;
    getInfomationField: GetInfomationField;
    constructor(private cdref: ChangeDetectorRef,
        private formsService: FormsService,
        private formBuilder: FormBuilder,
        private nzModalRef: NzModalRef,
        private nzModalNotification: NzNotificationService) { }


    ngOnInit(): void {
        if (this.data) {
            this.header = this.data.tooltip.header;
            this.rawContent = this.data.tooltip.content;
        }
        if (this.rawContent === undefined || this.rawContent === 'undefined') {
            this.body = this.data.tooltip;
            document.getElementById('eform-modal-body').classList.add('align-tooltip-content');
        }
        else {
            this.rawContent = new DOMParser().parseFromString(this.rawContent, 'text/html');
            this.body = this.rawContent.body.innerHTML;
            document.getElementById('eform-modal-body').classList.add('align-content');
        }
    }

    close() {
        this.nzModalRef.destroy();
    }
}